import React, { Component } from 'react'
import { Col, Row, Label, Button, Alert, Input, Modal, ModalHeader, ModalBody, FormGroup } from 'reactstrap'
import Select from 'react-select'
import gql from 'graphql-tag'
import withApolloClient from "../../withApolloClient"
import "./Modals.css"
import { LEGACY_SYSTEM_OPTIONS } from '../../Constants'

const UpdateIncidentMutation = gql`
  mutation UpdateIncident($input: UpdateIncidentMutationInput!) {
    updateIncident(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`


class AddExternalSystem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            systems: props.systems || [],
            error: null,
            successMessage: null,
            loading: false,
        }
    }

    handleClose = () => {
        this.setState({
            error: null,
            successMessage: null,
        })
        this.props.handleClose && this.props.handleClose()
    }

    handleAddMore = () => {
        this.setState((prevState) => ({
            systems: [...prevState.systems, { systemName: "", systemId: "" }],
        }))
    }

    handleSystemChange = (index, field, value) => {
        this.setState((prevState) => {
            const systems = [...prevState.systems]
            systems[index][field] = value
            return { systems }
        })
    }

    handleDeleteSystem = (index) => {
        if (this.state.systems.length <= 1) {
            this.setState({ error: "At least one system must remain." });
            return;
        }
        this.setState((prevState) => {
            const systems = [...prevState.systems];
            systems.splice(index, 1);
            return { systems };
        });
    }

    handleSave = () => {
        this.setState({ loading: true, error: null, successMessage: null });
        const legacyId = this.state.systems.filter(({ systemName, systemId }) => systemName && systemId).map(({ systemName, systemId }) => ({
            systemName: systemName,
            systemId: systemId,
        }));

        if (legacyId.length === 0) {
            this.setState({ error: "At least one valid system is required.", loading: false });
            return;
        }

        const input = {
            incidentId: this.props.incidentId,
            legacyId: legacyId,
        };

        this.props.apolloClient.mutate({
            mutation: UpdateIncidentMutation,
            variables: { input },
        }).then((res) => {
            if (res?.data?.updateIncident?.ok) {
                this.setState({ successMessage: "Successfully updated external systems.", error: null });
                this.props.refetchQuery?.();
                this.handleClose();
            } else {
                const msg = res?.data?.updateIncident?.errors?.[0]?.messages?.toString() || "An error occurred.";
                this.setState({ error: msg });
            }
        }).catch(() => {
            this.setState({ error: "An error has occurred." });
        }).finally(() => {
            this.setState({ loading: false });
        });
    }

    getFilteredOptions = (index) => {
        const { systems } = this.state;
        const selectedSystemNames = systems
            .filter((_, i) => i !== index) // Exclude the current dropdown
            .map(system => system.systemName); // Get selected system names

        return LEGACY_SYSTEM_OPTIONS.filter(option => !selectedSystemNames.includes(option.value)); // Exclude already selected options
    };

    render() {
        const { openModal, isUpdate } = this.props;
        const { systems, error, successMessage, loading } = this.state;

        const availableOptions = LEGACY_SYSTEM_OPTIONS.filter(
            option => !systems.some(system => system.systemName === option.value)
        );

        return (
            <Modal isOpen={openModal} toggle={this.handleClose} className="incident-modal">
                <ModalHeader>{isUpdate ? "Update External System" : "Add External System"}</ModalHeader>
                <ModalBody>
                    <Row>
                        {error && <Col xs={12}><Alert color="danger">{error}</Alert></Col>}
                        {successMessage && <Col xs={12}><Alert color="success">{successMessage}</Alert></Col>}
                    </Row>
                    {systems.map((system, index) => (
                        <Row key={index} className="mb-3">
                            <Col>
                                <FormGroup>
                                    <Label>System Name</Label>
                                    <Select
                                        className="bos-custom-select"
                                        classNamePrefix="bos-select"
                                        options={this.getFilteredOptions(index)}
                                        value={LEGACY_SYSTEM_OPTIONS.find(opt => opt.value === system.systemName)}
                                        onChange={(opt) => this.handleSystemChange(index, "systemName", opt.value)}
                                        isDisabled={isUpdate && !!this.props.systems?.find(s => s.systemName === system.systemName)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>System ID</Label>
                                    <Input
                                        type="text"
                                        value={system.systemId}
                                        onChange={(e) => this.handleSystemChange(index, "systemId", e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            {!isUpdate &&
                                <Col xs={1}>
                                    <FormGroup>
                                        <Label>&nbsp;</Label>
                                        <Button
                                            color="danger"
                                            onClick={() => this.handleDeleteSystem(index)}
                                            disabled={systems.length <= 1}
                                            title={systems.length <= 1 ? "At least one system must remain." : "Delete"}
                                        >
                                            <i className="fa fa-trash" />
                                        </Button>
                                    </FormGroup>
                                </Col>
                            }
                        </Row>
                    ))}

                    {!isUpdate && availableOptions.length > 0 &&
                        <Button color="link" onClick={this.handleAddMore}>
                            + Add More
                        </Button>
                    }
                </ModalBody>
                <Row className="px-3 text-right mb-3">
                    <Col>
                        <Button color="primary" onClick={this.handleSave} disabled={loading}>
                            {loading ? "Saving..." : "Save"}
                        </Button>
                        <Button color="secondary" onClick={this.handleClose} className="ml-2">
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Modal>
        );
    }
}
export default withApolloClient(AddExternalSystem)
